<template>
  <div :class="[$style[`${props.gameClass}`], $style['game-info']]">
    <div :class="$style['info-title']">
      <component :is="components[props.gameIcon]"></component>
      <span>{{ props.gameName }}</span>
    </div>
    <!-- <div :class="$style['game-numbers']">12 players ฿ 15 850</div> -->
  </div>
</template>

<script setup lang="ts">
import CrashIcon from "~/components/Icon/Crash.vue";
import LadderIcon from "~/components/Icon/Ladder.vue";
import RouletteIcon from "~/components/Icon/Roulette.vue";
import SapperIcon from "~/components/Icon/Sapper.vue";
import TowerIcon from "~/components/Icon/Tower.vue";
import UpgradeIcon from "~/components/Icon/Upgrade.vue";
import WheelIcon from "~/components/Icon/Wheel.vue";
import ContractsIcon from "~/components/Icon/Contracts.vue";

const components: Record<string, Component> = {
  CrashIcon,
  LadderIcon,
  RouletteIcon,
  SapperIcon,
  TowerIcon,
  UpgradeIcon,
  WheelIcon,
  ContractsIcon,
};

const props = defineProps<{
  gameName: string;
  gameIcon: string;
  gameClass: string;
}>();
</script>

<style lang="scss" module>
.game-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  letter-spacing: -0.16px;
  font-family: "PP-Pangram-Sans-BC-Rounded";
}
.info-title {
  display: flex;
}
.main {
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -0.32px;
  svg {
    width: 40px;
    height: 40px;
    margin-right: 8px;
    fill: var(--general-white);
  }
  .game-numbers {
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
  }
}
.minor,
.slide-game {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.18px;
  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    fill: var(--general-white);
  }
  .game-numbers {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: -0.12px;
    opacity: 0.3;
    @media screen and (max-width: 650px) {
      font-size: 10px;
      line-height: 10px;
      opacity: 1;
    }
  }
}

@media screen and (max-width: 1280px) {
  .main {
    font-size: 26px;
    line-height: 30px;
    svg {
      width: 32px;
      height: 32px;
    }
  }
}
@media screen and (max-width: 475px) {
  .minor,
  .slide-game {
    .info-title {
      font-size: 14px;
      line-height: 20px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
